<!--
author:harry
-->
<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.CompanyNo" placeholder="公司编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.UserNo" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="GetPage" :loading="listLoading" style="width:80px"> 查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" fit stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" fixed="left" width="60" label="行号"></el-table-column>
			<el-table-column prop="userState" label="状态" width="100" align="left">
				<template slot-scope="scope">
					<i v-if="scope.row.userState==0" class="fa fa-unlock-alt" aria-hidden="true" style="font-size: 20px;"></i>
					<i v-else class="fa fa-lock" aria-hidden="true" style="font-size: 20px;"></i>
				</template>
			</el-table-column>
			<el-table-column prop="userCompanyno" label="公司编号" min-width="80"></el-table-column>
			<el-table-column prop="userName" label="姓名" min-width="100"></el-table-column>
			<el-table-column prop="userNo" label="账号" min-width="100"></el-table-column>
			<el-table-column prop="userPhone" label="电话" min-width="100"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" min-width="200" align="center" :formatter="dateFormat"></el-table-column>
			<el-table-column prop="cretaeIp" label="最后登录IP" min-width="150"></el-table-column>
			<el-table-column fixed="right" label="操作" width="210">
				<template slot-scope="scope">
					<el-button size="small" plain @click="handleRole(scope.$index, scope.row)">权限</el-button>
					<el-button size="small" type="primary" plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pagesize" :page-sizes="[10,20,30]" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--新增 编辑界面-->
		<el-dialog :title="editmode ?'编辑':'新增'" :visible.sync="dataFormVisible" :close-on-click-modal="false" width="60%" @close="resetForm('dataForm')" >
			<el-form :model="dataForm" label-width="120px" :rules="dataFormRules" ref="dataForm">
				<el-row class="dialog-mastertitle" style="margin-bottom:10px">用户管理</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="姓名" prop="userName">
							<el-input v-model="dataForm.userName" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="账号" prop="userNo">
							<el-input v-model="dataForm.userNo" auto-complete="off" :readonly="editmode ?true:false"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="密码" prop="userPass">
							<el-input v-model="dataForm.userPass" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="手机号" prop="userPhone">
							<el-input v-model="dataForm.userPhone" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="用户状态" prop="userState">
							<el-select v-model="dataForm.userState" auto-complete="off" placeholder="请选择" style="width: 100%">
								<el-option label="正常" :value="0"></el-option>
								<el-option label="停用" :value="1"></el-option>
								<el-option label="待审核" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="公司编号" prop="userCompanyno">
							<el-input v-model="dataForm.userCompanyno" auto-complete="off" :readonly="editmode ?true:false"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="是否超级用户" prop="issupper">
							<el-switch v-model="dataForm.issupper"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="resetForm('dataForm')">取消</el-button>
				<el-button type="primary" @click.native="Submit" :loading="dataLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--权限管理界面-->
		<el-dialog title="编辑" :visible.sync="roleFormVisible" :close-on-click-modal="false" width="45%">
			<el-row class="dialog-mastertitle" style="margin-bottom:10px">用户权限管理</el-row>
			<el-tabs type="border-card">
				<el-tab-pane label="功能权限">
					<el-tree :props="props" :data="roleList" node-key="powerNo" ref="roletree" check-strictly @check-change="handleCheckChange" :default-checked-keys="rolecheck" show-checkbox style="height: 350px;overflow: auto;">
					</el-tree>
				</el-tab-pane>
			</el-tabs>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="roleFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="RoleSubmit" :loading="roledataLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { Add, Update, UpdatePower, Delete, GetPage } from '../../api/User';
	import { GetList } from '../../api/PowerSet';
	import { GetDict } from '../../api/DataDict';
	import { hashcode } from '../../utils/validate';
	export default {
		data() {
			return {
				filters: {
					UserNo: '',
					CompanyNo: ''
				},
				datalist: [],
				PowerGroup: [], //用户群组
				total: 0, //总页数
				page: 1, //第几页
				pagesize: 10, //每业显示条数
				editmode: false, //编辑模式
				listLoading: false, //列表加载动画
				dataLoading: false, //提交动画		
				roledataLoading: false, //提交动画		
				dataFormVisible: false, //编辑界面是否显示
				roleFormVisible: false, //权限管理界面是否显示
				edithashcode: '',
				dataFormRules: {
					userName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					userNo: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					userPass: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					userPhone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					userState: [{
						required: true,
						message: '请选择用户状态',
						trigger: 'change'
					}],
				},
				//编辑界面数据
				dataForm: {},
				PowerRoleList: [],
				ReportRoleList: [],
				roleList: [],
				rolecheck: [],
				edituserno: '',
				editcompanyNo: "",
				props: {
					children: 'children',
					label: 'powerName'
				},
				reportprops: {
					children: 'children',
					label: 'reportName'
				}
			}
		},
		methods: {
			//每页条数
			handleSizeChange(val) {
				this.pagesize = val;
				this.GetPage();
			},
			checkPremission(role) {
				return this.$store.getters.funs.indexOf(role) > -1;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.GetPage();
			},
			handleCheckChange(data, checked) {
				if(checked) {
					var arr1 = this.$refs.roletree.getCheckedKeys();
					arr1.push(data.parentNo)
					this.$refs.roletree.setCheckedKeys(arr1);
				}
			},
			//获取数据列表
			GetPage() {
				let para = {
					page: this.page,
					row: this.pagesize
				};
				//添加查询参数
				for(let x in this.filters) {
					if(this.filters[x]) para[x] = this.filters[x];
				};
				this.listLoading = true;
				GetPage(para).then(response => {
					this.total = response.data.total;
					this.datalist = response.data.rows;
					this.listLoading = false;
				}).catch((res) => {
					this.listLoading = false;
				})
			},
			//删除
			handleDel: function(index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = {
						UserNo: row.userNo,
						companyNo: row.userCompanyno
					};
					Delete(para).then((res) => {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.listLoading = false;
						this.GetPage();
					}).catch((res) => {
						this.listLoading = false;
					})
				});
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.dataFormVisible = true;
				this.editmode = true;
				this.dataForm = Object.assign({}, row);
				this.edithashcode = hashcode(this.dataForm);
			},
			//显示权限管理界面
			handleRole: function(index, row) {
				this.roleFormVisible = true;
				this.edituserno = row.userNo;
				this.editcompanyNo = row.userCompanyno;
				//通过功能菜单列表数组生成树状结构				
				function generatePermissionTree(data) {
					data.forEach(function(item) {
						delete item.children;
					});
					var map = {};
					data.forEach(function(item) {
						map[item.powerNo] = item;
					});
					var val = [];
					data.forEach(function(item) {
						var parent = map[item.parentNo];
						if(parent) {
							(parent.children || (parent.children = [])).push(item);
						} else {
							val.push(item);
						}
					});
					return val;
				}
				this.roleList = generatePermissionTree(this.PowerRoleList);
				//获取该用户的权限列表，把有权限的勾选 
				this.rolecheck = [];
				if(row.userPower) {
					this.rolecheck = row.userPower.split(";");
				}
			},

			findPowerGroupName(val) {
				let obj = {};
				obj = this.PowerGroup.find((item) => {
					return item.groupNo === val;
				});
				if(obj) {
					return obj.groupName;
				} else {
					return "";
				}
			},
			//显示新增界面
			handleAdd: function() {
				this.dataFormVisible = true;
				this.edithashcode = '';
				this.editmode = false;
				this.dataForm = {};
			},
			resetForm(formName) {
				this.dataFormVisible = false;
				this.$refs[formName].resetFields();
			},
			//编辑提交
			Submit: function() {
				// 通过hashcode判断是否数据是否有改动，没有改动则不需要提交数据
				let newhashcode = hashcode(this.dataForm);
				if(newhashcode == this.edithashcode) {
					this.dataFormVisible = false;
					return;
				}
				this.$refs.dataForm.validate((valid) => {
					if(valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.dataLoading = true;
							//加载参数
							let para = {};
							para['userNo'] = this.dataForm.userNo;
							para['userName'] = this.dataForm.userName;
							para['userPass'] = this.dataForm.userPass;
							para['userState'] = this.dataForm.userState;
							para['issupper'] = this.dataForm.issupper;
							para['userCompanyno'] = this.dataForm.userCompanyno;
							para['userPhone'] = this.dataForm.userPhone;

							if(this.editmode) {
								//修改
								Update(para).then((res) => {

									this.$message({
										message: '提交成功',
										type: 'success'
									});

									this.dataFormVisible = false;
									this.GetPage();
									this.dataLoading = false;
								}).catch((res) => {
									this.dataLoading = false;
								})
							} else {
								//新增
								Add(para).then((res) => {

									this.$message({
										message: '提交成功',
										type: 'success'
									});

									this.dataFormVisible = false;
									this.GetPage();
									this.dataLoading = false;
								}).catch((res) => {
									this.dataLoading = false;
								})
							}

						});
					}
				});
			},
			//编辑提交
			RoleSubmit: function() {
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					//this.roledataLoading = true;
					//保存时 要加上节点 和 叶子
					var funlist = this.$refs.roletree.getCheckedKeys();
					let para = {
						userNo: this.edituserno,
						CompanyNo: this.editcompanyNo,
						powerfunlist: funlist.join(';')
					};
					UpdatePower(para).then((res) => {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.roleFormVisible = false;
						this.GetPage();
						this.roledataLoading = false;
					}).catch((res) => {
						this.roledataLoading = false;
					})
				});
			},
		},
		mounted() {
			//获取功能菜单权限列表
			GetList().then(response => {
				this.PowerRoleList = response.data;
			});
			this.GetPage();
		}
	}
</script>
<style scoped lang="scss">

</style>